/**
 * Smooth Scroll for Anchor Links
 * Handles smooth scrolling to anchor links on the page
 */

function initSmoothScroll(): void {
	// Get all anchor links that start with #
	const anchorLinks = document.querySelectorAll('a[href^="#"]');

	anchorLinks.forEach((link) => {
		link.addEventListener('click', (e) => {
			const href = link.getAttribute('href');
			
			// Skip empty or just # links
			if (!href || href === '#') {
				return;
			}

			// Find the target element
			const targetId = href.substring(1);
			const targetElement = document.getElementById(targetId);

			if (targetElement) {
				e.preventDefault();

				// Smooth scroll to the target
				targetElement.scrollIntoView({
					behavior: 'smooth',
					block: 'start',
				});

				// Update URL without jumping
				if (history.pushState) {
					history.pushState(null, '', href);
				}
			}
		});
	});
}

// Initialize on DOM ready
if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', initSmoothScroll);
} else {
	initSmoothScroll();
}
